exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar {\r\n      margin-bottom: 0;\r\n      border-radius: 0;\r\n    }\r\n        \r\n .row.content {height: 450px}\r\n \r\n .sidenav {\r\n   padding-top: 20px;\r\n   background-color: #f1f1f1;\r\n   height: 100%;\r\n }\r\n \r\n footer {\r\n   background-color: #555;\r\n   color: white;\r\n   padding: 15px;\r\n }\r\n \r\n @media screen and (max-width: 767px) {\r\n   .sidenav {\r\n     height: auto;\r\n     padding: 15px;\r\n   }\r\n   .row.content {height:auto;} \r\n }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 316
// module chunks = 0